/**
 * Smooth-scrolls to an in-page section by id.
 *
 * Plain `href="#id"` anchors don't auto-scroll here because the app's
 * `withInMemoryScrolling` router config puts the browser's scroll
 * restoration in manual mode, and only re-enables it for navigations that
 * go through the Angular Router — not for raw fragment link clicks.
 */
export function scrollToSection(id: string, event?: Event): void {
  event?.preventDefault();
  document.getElementById(id)?.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
  });
}
